export var PATHS;
(function (PATHS) {
    PATHS["LANDING"] = "/";
    PATHS["LOGIN"] = "/login";
    PATHS["FORGOT_PASSWORD"] = "/forgot-password";
    PATHS["RESET_PASSWORD"] = "/reset-password";
    PATHS["LOGIN_ERROR"] = "/login/login-error";
    PATHS["AUTH_ERROR"] = "/auth-error";
    PATHS["HOME"] = "/home";
    PATHS["OVERVIEW"] = "/overview/:assessmentId";
    PATHS["RESULTS"] = "/results/:assessmentId";
    PATHS["DASHBOARD"] = "/dashboard";
    PATHS["ADMIN_DASHBOARD"] = "/admin/dashboard";
    PATHS["TERMS_CONDITIONS_AGREEMENT"] = "/terms-conditions-agreement";
})(PATHS || (PATHS = {}));
